import { Layout } from 'react-grid-layout';

export const EXPORT_ROW_HEIGHT = 80;
export const EXPORT_GRID_MARGIN_Y = 12;
export const EXPORT_GRID_PADDING = 10;
export const EXPORT_PREVIEW_BOTTOM_PADDING = 40;

/** Match react-grid-layout container height: rows * rowHeight + margins + padding */
export const getLayoutGridHeight = (
  layout: Layout[],
  bottomPadding = EXPORT_PREVIEW_BOTTOM_PADDING,
): number => {
  if (layout.length === 0) return 300;

  const rowCount = Math.max(...layout.map((item) => item.y + item.h));
  const contentHeight =
    rowCount * EXPORT_ROW_HEIGHT +
    Math.max(0, rowCount - 1) * EXPORT_GRID_MARGIN_Y +
    EXPORT_GRID_PADDING * 2;

  return contentHeight + bottomPadding;
};

export const measureGridContentHeight = (
  wrapper: HTMLElement,
  layout: Layout[],
  bottomPadding = EXPORT_PREVIEW_BOTTOM_PADDING,
): number => {
  let maxBottom = 0;

  wrapper.querySelectorAll('.react-grid-item').forEach((item) => {
    const gridItem = item as HTMLElement;
    const inner = gridItem.querySelector('.dashboard-item') as HTMLElement | null;
    const contentHeight = inner
      ? Math.max(inner.scrollHeight, inner.offsetHeight)
      : Math.max(gridItem.scrollHeight, gridItem.offsetHeight);
    maxBottom = Math.max(maxBottom, gridItem.offsetTop + contentHeight);
  });

  const layoutHeight = getLayoutGridHeight(layout, 0);
  return Math.max(maxBottom, layoutHeight) + bottomPadding;
};
